<template>
  <Block v-bind="{ title }" v-model="toggleValue" :disabled>
    <component
      :is="component"
      v-if="toggleValue"
      v-model="componentModel"
      :disabled
      @ready="handleReady"
    />
  </Block>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref, watch } from 'vue'

import { TaggingRuleActionType } from './utils/enums'
import { TaggingRuleAction } from './utils/types'

import { ACTION_TYPE_TITLE } from './utils/const'

import Block from '@/modules/Rules/components/Block.vue'
import ActionAccount from './components/ActionAccount.vue'
import ActionCategory from './components/ActionCategory.vue'
import ActionCounterparty from './components/ActionCounterparty.vue'
import ActionSign from './components/ActionSign.vue'
import ActionSubcategory from './components/ActionSubcategory.vue'
import ActionTag from './components/ActionTag.vue'

type Props = {
  name: TaggingRuleActionType
  disabled?: boolean
}

const props = defineProps<Props>()

const modelValue = defineModel<TaggingRuleAction[]>({
  default: () => [],
})

const toggleValue = ref(false)

const title = computed(
  () => ACTION_TYPE_TITLE[props.name as keyof typeof ACTION_TYPE_TITLE],
)

const component = computed(() => {
  switch (props.name) {
    case TaggingRuleActionType.ADD_TAG:
      return ActionTag
    case TaggingRuleActionType.SET_CATEGORY:
      return ActionCategory
    case TaggingRuleActionType.SET_SUB_CATEGORY:
      return ActionSubcategory
    case TaggingRuleActionType.SET_COUNTERPARTY:
      return ActionCounterparty
    case TaggingRuleActionType.SET_SIGN:
      return ActionSign
    default:
      return ActionAccount
  }
})

const modelIndex = computed(() =>
  modelValue.value.findIndex(item => item.type === props.name),
)

const componentModel = computed({
  get: () => modelValue.value[modelIndex.value],
  set: value => {
    modelValue.value = modelValue.value.map((item, index) =>
      index === modelIndex.value ? value : item,
    )
  },
})

const handleReady = (el: HTMLInputElement) => {
  el.focus()
}

watch(toggleValue, value => {
  if (value) {
    modelValue.value = [
      ...modelValue.value,
      {
        type: props.name,
        value: undefined,
        tag_ids: undefined,
      },
    ]
  } else {
    modelValue.value = modelValue.value.filter(
      (_, index) => index !== modelIndex.value,
    )
  }
})

onBeforeMount(() => {
  toggleValue.value = modelIndex.value !== -1
})
</script>
